import {
  MessageTooltip,
  Spacer,
  ButtonDS,
  LockOpenOutlined,
  EllipseMenu,
} from "@qivia/ui";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ReasonsRefusedEnum } from "../transactionsAPI";

export const DisplayReasonsRefused = (props: {
  reasonsRefused: ReasonsRefusedEnum[];
  setIsMerchantAuthorizationModalVisible: (value: boolean) => void;
  categoryCorrectionDisplayed: boolean;
}) => {
  const { t } = useTranslation();
  const [reasonIndex, setReasonIndex] = useState<number>(0);
  const primaryRefusedReasons: ReasonsRefusedEnum[] = useMemo(() => {
    return [
      "IN_OPPOSITION_CARD",
      "INACTIVE_CARD",
      "INACTIVE_PIN_ONLINE_CARD",
      "BLOCKED_PIN_OFFLINE_CARD",
      "EARLY_RETRY",
      "ROTATION_REQUEST_TRANSACTIONS_EXCEEDED",
      "ALREADY_REJECTED_ROTATION_REQUEST",
      "INACTIVE_COMPANY",
    ];
  }, []);
  const primaryRefusedReason = useMemo(
    () =>
      primaryRefusedReasons.filter((reason) =>
        props.reasonsRefused.includes(reason),
      )[0],
    [primaryRefusedReasons, props.reasonsRefused],
  );

  if (primaryRefusedReason) {
    return (
      <MessageTooltip
        title={t(
          `transactions.reasonsRefused.${primaryRefusedReason.toLowerCase()}.title`,
        )}
        text={t(
          `transactions.reasonsRefused.${primaryRefusedReason.toLowerCase()}.text`,
        )}
        type={"ERROR"}
      />
    );
  }

  const reasonsRefusedSorted = ReasonsRefusedDict.filter((reason) =>
    props.reasonsRefused.includes(reason as ReasonsRefusedEnum),
  );

  if (reasonsRefusedSorted.length < 1) return;

  const isOnlyOneReasonRefused = reasonsRefusedSorted.length === 1;

  return (
    <>
      <Spacer y={2} />
      <MessageTooltip
        title={t(
          `transactions.reasonsRefused.${reasonsRefusedSorted[
            reasonIndex
          ].toLowerCase()}.title`,
        )}
        text={t(
          `transactions.reasonsRefused.${reasonsRefusedSorted[
            reasonIndex
          ].toLowerCase()}.text`,
        )}
        type={"ERROR"}
        button={
          props.categoryCorrectionDisplayed &&
          ["UNAUTHORIZE_MERCHANT", "UNKNOWN_MERCHANT_CODE"].includes(
            reasonsRefusedSorted[reasonIndex] as ReasonsRefusedEnum,
          ) ? (
            <ButtonDS
              text={t(`transactions.reasonsRefused.button.authorizedMerchant`)}
              format={"fill"}
              buttonType={"primary"}
              leftIcon={<LockOpenOutlined />}
              onClick={() => props.setIsMerchantAuthorizationModalVisible(true)}
            />
          ) : undefined
        }
      />
      {!isOnlyOneReasonRefused && (
        <EllipseMenu
          sections={reasonsRefusedSorted}
          selectedSection={reasonIndex}
          setSelectedSection={setReasonIndex}
        />
      )}
    </>
  );
};

const ReasonsRefusedDict = [
  "NO_DRIVER",
  "PIN_BLOCKED",
  "EXCEEDED_LIMITS",
  "NO_FUNDS",
  "UNAUTHORIZE_MERCHANT",
  "UNAUTHORIZE_MERCHANT_CODE",
  "UNKNOWN_MERCHANT_CODE",
  "UNAUTHORIZE_MERCHANT_NAME",
  "UNKNOWN_MERCHANT_NAME",
  "WRONG_PLACE",
  "WRONG_DAY",
  "WRONG_TIME",
  "ONLINE_PAYMENT_UNAUTHORIZED",
];
